import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../store/app-state";
import { LoadingIcon } from "../content/loading/loading.styled";
import { Container } from "./comment-modal.styled";
import Comments from "./components/comments";
import { useEffect } from "react";
import { fetchRecruiterComments } from "../../store/event/event-actions";
interface CommentModalProps {
  candidateId?: string;
}
const CommentModal: React.FC<CommentModalProps> = ({ candidateId }) => {
  const { recruiterComments } = useSelector(
    (state: AppState) => state.eventState
  );
  const dispatch = useDispatch();
  
  useEffect(() => {
    if (candidateId) dispatch(fetchRecruiterComments(candidateId));
  }, [dispatch, candidateId]);

  return !recruiterComments.loading ? (
    <Container>
      <Comments candidateId={candidateId} />
    </Container>
  ) : (
    <Container>
      <LoadingIcon size={80} />
    </Container>
  );
};

export default CommentModal;
